var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditSingleEventForm',{attrs:{"initial-form-data":_vm.singleEvent,"on-form-saved":_vm.onSingleEventSaved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }